import React from 'react';
import { DialogTitle, DialogContent, Typography, TextField, Checkbox, FormControlLabel } from '@mui/material';
import { SimpleModal } from 'components/Modal';
import { StyledButton } from 'components/Buttons/DefaultButton/DefaultButton.styles';
import { ContactField, ModalButtonContainer } from '../FeedbackPage.styles';

interface NegativeFeedbackModalProps {
  isOpen: boolean;
  onClose: () => void;
  hygienistFirstName: string;
  negativeFeedback: string;
  contactRequested: boolean;
  contactName: string;
  onFeedbackChange: (feedback: string) => void;
  onContactRequestedChange: (requested: boolean) => void;
  onContactNameChange: (name: string) => void;
  onSubmit: () => void;
}

const NegativeFeedbackModal: React.FC<NegativeFeedbackModalProps> = ({
  isOpen,
  onClose,
  hygienistFirstName,
  negativeFeedback,
  contactRequested,
  contactName,
  onFeedbackChange,
  onContactRequestedChange,
  onContactNameChange,
  onSubmit,
}) => {
  return (
    <SimpleModal isOpen={isOpen} onClose={onClose}>
      <DialogTitle sx={{ textAlign: 'center' }}>Uh Oh.</DialogTitle>
      <DialogContent>
        <Typography align="left" gutterBottom>
          Can you tell us briefly where {hygienistFirstName} went wrong?
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={4}
          placeholder="You can provide details here..."
          value={negativeFeedback}
          onChange={(e) => onFeedbackChange(e.target.value)}
          margin="normal"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={contactRequested}
              onChange={(e) => onContactRequestedChange(e.target.checked)}
            />
          }
          label="Please contact me about this"
        />
        <ContactField $visible={contactRequested}>
          <TextField
            fullWidth
            placeholder="your name"
            value={contactName}
            onChange={(e) => onContactNameChange(e.target.value)}
          />
        </ContactField>
      </DialogContent>
      <ModalButtonContainer>
        <StyledButton
          variant="contained"
          onClick={onSubmit}
        >
          Submit
        </StyledButton>
        <StyledButton
          variant="outlined"
          onClick={onClose}
        >
          Go Back
        </StyledButton>
      </ModalButtonContainer>
    </SimpleModal>
  );
};

export default NegativeFeedbackModal;
